<div class="alert alert-{{ type }} mb-0" role="alert">
    <h4>{{ message }}</h4>    
</div>
